import { INO_API_BASE } from '@/Module/Core/Constant';

export const GRADE_API = {
  GET_UNIQUE_URL_JSON: `${INO_API_BASE}/unique-url-jsons`,
  GET_STRATEGY_LEVEL_INFO: `${INO_API_BASE}/strategy-level-infos`,
};
